import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatToolbarModule, MatButtonModule, MatIconModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { MainLayoutPage } from './pages/main-layout/main-layout.page';
import { MainContentComponent } from './components/main-content/main-content.component';
import { MainLayoutMenuComponent } from './components/main-layout-menu/main-layout-menu.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [MainLayoutPage, MainContentComponent, MainLayoutMenuComponent, MainMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    SharedModule,
  ],
})
export class LayoutModule {}
